import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import web from "../assets/portfolio/website.svg";

function WebComponent() {
  return (
    <div className="web">
      <div className="content-web-box shadow-sm">
        <Container>
          <Row className="content-web">
            <Col xs={12} md={6}>
              <img src={web} alt="..." className="img-fluid" />
            </Col>
            <Col xs={12} md={6}>
              <h4>
                Website We've{" "}
                <span style={{ fontSize: "40px", color: "#22a178" }}>
                  Developed
                </span>
              </h4>
              <p>
                Building website is easy. But building website with good
                performance is tricky. Here, we've some example to showcase.
              </p>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}

export default WebComponent;
